import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactGA from "react-ga4";

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    console.log(location);

    // TODO Only for BabyQuip
    ReactGA.initialize('G-L767PK9FQD');

    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search, title: location.pathname + location.search});
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  location: PropTypes.shape().isRequired,
};

export default withRouter(ScrollToTop);
